import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileText, Eye, Download, ShieldAlert, ExternalLink } from "lucide-react";
import { toast } from "sonner";

// Onglet Documents contextuel : lit le registre documentaire central filtré par entité.
export function EntityDocuments({ filterKey, id, testid = "entity-documents" }) {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    if (!id) return;
    api.get("/registry", { params: { [filterKey]: id } })
      .then((r) => setRows(r.data.documents))
      .catch((e) => { if (e.response?.status === 403) setDenied(true); });
  }, [filterKey, id]);

  const openFile = async (url) => {
    try { const r = await api.get(url.replace(/^\/api/, ""), { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  if (denied) return <p className="text-sm text-slate-400" data-testid={`${testid}-denied`}>{t("accessDenied")}</p>;
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex justify-end">
        <Link to={`/documents?${filterKey}=${id}`} data-testid={`${testid}-open-registry`}>
          <Button size="sm" variant="outline" className="gap-1"><ExternalLink className="h-4 w-4" />{t("openInRegistry")}</Button>
        </Link>
      </div>
      {rows.length === 0 ? <p className="text-sm text-slate-400">{t("noData")}</p> :
        rows.map((d) => (
          <Card key={d.id} className="border-slate-200 p-3 flex items-center justify-between gap-2" data-testid="entity-doc-row">
            <div className="flex items-center gap-2 min-w-0">
              <FileText className="h-4 w-4 text-slate-400 shrink-0" />
              <span className="text-sm text-slate-700 truncate">{d.name}</span>
              <Badge className="bg-slate-100 text-slate-500 border-0 text-xs">{d.category}</Badge>
              {d.sensible && <Badge className="bg-red-100 text-red-700 border-0 text-xs gap-1"><ShieldAlert className="h-3 w-3" />{t("sensitive")}</Badge>}
              <Badge className="bg-slate-100 text-slate-500 border-0 text-xs">{d.status}</Badge>
              <span className="text-[11px] text-slate-400">{(d.deposited_at || "").slice(0, 10)}</span>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <Button size="sm" variant="ghost" className="gap-1 h-8" onClick={() => openFile(d.preview_url)}><Eye className="h-4 w-4" />{t("preview")}</Button>
              <Button size="sm" variant="ghost" className="gap-1 h-8" onClick={() => openFile(d.download_url)}><Download className="h-4 w-4" />{t("download")}</Button>
            </div>
          </Card>
        ))}
    </div>
  );
}
